import { storeToRefs } from 'pinia'
import { useCustomerService as useCoreCustomerService, ZendeskFieldIds, ZendeskBu } from '@myfunnow/web-core'

import { useAuthStore } from '@/store/auth'
import { useAppStore } from '@/store/app'
import { useRegionStore } from '@/store/region'

import { getZendeskJwt } from '@/service/login'

export function useCustomerService() {
  const config = useRuntimeConfig()

  const authStore = useAuthStore()
  const appStore = useAppStore()
  const regionStore = useRegionStore()

  const route = useRoute()

  const { localeProperties } = useI18n()

  const language = computed(() => localeProperties.value.language || '')
  const { localeLowerCaseString: lowerCasedLocale } = useLowerCase(language)

  const { isLogin, user } = storeToRefs(authStore)
  const { regionInfo, regionDetectInfo } = storeToRefs(regionStore)

  const isCsBubbleShown = computed(() => {
    const isOrderPages = checkIfOrderListPage(route.name) || checkIfOrderDetailPage(route.name)

    if (!isLoaded.value) {
      return false
    }
    if (appStore.isDesktopScreen && hasOpened.value) {
      return true
    }
    if (!isLogin.value) {
      return false
    }
    if (isOrderPages) {
      return true
    }

    return false
  })

  const baseFields = computed(() => {
    const conversationFields = [
      { id: ZendeskFieldIds.USER_EMAIL, value: user.value?.email || '' },
      { id: ZendeskFieldIds.USER_ID, value: `${user.value?.uid || ''}` },
      { id: ZendeskFieldIds.USER_PHONE, value: user.value?.phone || '' },
      { id: ZendeskFieldIds.BU, value: ZendeskBu.EATIGO },
      { id: ZendeskFieldIds.COUNTRY, value: regionInfo.value?.country_code ?? (regionDetectInfo.value?.country_code || '') },
      { id: ZendeskFieldIds.LANGUAGE, value: lowerCasedLocale.value },
      { id: ZendeskFieldIds.CONTACT_TYPE, value: 'b2c' },
      { id: ZendeskFieldIds.CHANNEL, value: 'web' },
    ]

    return conversationFields
  })

  const { initial, handleOpen, hasOpened, hasUnreadMessages, isLoaded, setProperties } = useCoreCustomerService({
    isLogin,
    zendeskKey: config.public.zendeskKey,
    baseFields,
    getZendeskJwt,
  })

  return {
    initialCs: initial,
    handleOpen,
    setProperties,
    isCsBubbleShown,
    isCsLoaded: isLoaded,
    hasUnreadMessages,
  }
}
